import deepClone from '../deepClone';

function hasContent(group) {
  return (
    (group.filters && group.filters.length > 0) ||
    (group.filterGroups && group.filterGroups.length > 0) ||
    (group.saved_filters && group.saved_filters.length > 0) ||
    (group.savedFilters && group.savedFilters.length > 0)
  );
}

function pruneFilterGroup(group, dimensionSet) {
  if (group.filters) {
    group.filters = group.filters.filter((f) => !dimensionSet.has(f.filterField));
  }

  if (group.filterGroups) {
    group.filterGroups = group.filterGroups
      .map((fg) => pruneFilterGroup(fg, dimensionSet))
      .filter((fg) => hasContent(fg));
  }

  return group;
}

export default function excludeFiltersByDimensions(filterObj, dimensionSet) {
  if (!filterObj || !dimensionSet?.size) {
    return filterObj;
  }

  return pruneFilterGroup(deepClone(filterObj), dimensionSet);
}
